
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Bycullatopunecabservice() {



    const cardData =
    {
        keyword: ' Byculla to Pune Cab Service',
        heading: 'Skyline Cabs: Byculla to Pune Cab Service',
        headingDescription: 'Skyline Cabs offers trusted and efficient Byculla to Pune Cab Service for a seamless intercity travel experience. Whether you are heading to Pune for business, personal reasons, or a weekend retreat, our clean and comfortable vehicles, along with professional drivers, ensure a smooth and safe journey. Enjoy on-time pickups from Byculla, transparent fare structures, and 24/7 customer support with Skyline Cabs. Book your Byculla to Pune cab today and travel worry-free with complete comfort.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Byculla to Pune Cab Service Rates",
    "description": "Skyline Cabs offers affordable and transparent pricing for cab services from Byculla to Pune. Our fare includes all charges with no hidden fees, ensuring you get the best value for a smooth and reliable journey."
  },
  {
    "name": "Byculla to Pune Taxi Service",
    "description": "Travel comfortably from Byculla to Pune with Skyline Cabs' professional taxi service. Whether for business or leisure, our range of well-maintained vehicles ensures a relaxed and timely ride."
  },
  {
    "name": "Mahalaxmi to Pune Cab Service",
    "description": "Skyline Cabs provides dependable cab service from Mahalaxmi to Pune. Choose from a fleet of sedans, SUVs, and luxury cars for a personalized, safe, and comfortable journey to your destination."
  },
  {
    "name": "Colaba to Pune Taxi",
    "description": "Book a taxi from Colaba to Pune with Skyline Cabs for a premium travel experience. Our trained drivers and clean, well-equipped vehicles guarantee a peaceful and convenient trip."
  },
  {
    "name": "Parel to Pune Cab Service",
    "description": "Skyline Cabs offers hassle-free cab services from Parel to Pune. With prompt pickups, courteous drivers, and multiple vehicle choices, we make your intercity travel stress-free and affordable."
  },
  {
    "name": "Sion to Pune Cab Booking",
    "description": "Looking for a ride from Sion to Pune? Skyline Cabs offers easy and fast online cab booking. Enjoy a safe journey with our professional drivers and clean, air-conditioned vehicles."
  },
  {
    "name": "Wadala to Pune Cab Booking",
    "description": "Book a cab from Wadala to Pune with Skyline Cabs for a smooth and reliable journey. Our simple booking process, experienced drivers, and comfortable cars ensure peace of mind for your travel plans."
  },
  {
    "name": "Byculla Cabs Service",
    "description": "Skyline Cabs provides local and outstation cab services from Byculla. Whether you're heading to Pune or need a local ride, our affordable rates and professional service guarantee customer satisfaction."
  },
  {
    "name": "Outstation Cab Service in Byculla",
    "description": "Skyline Cabs offers reliable outstation cab services from Byculla to popular destinations like Pune, Lonavala, and Nashik. Choose from a variety of vehicles with professional drivers for a comfortable trip."
  },
  {
    "name": "Outstation Cab Service in Byculla Number",
    "description": "To book an outstation cab from Byculla, contact Skyline Cabs at [Insert Contact Number]. Our customer support is available 24/7 to help you with reservations, fare inquiries, and travel assistance."
  },
  {
    "name": "Outstation Cab Service in Byculla Number Mumbai",
    "description": "Skyline Cabs is your trusted travel partner for outstation taxi services from Byculla, Mumbai. Call us at [Insert Contact Number] to book safe and affordable rides to Pune and other cities."
  }
],
"tableData": [
  ["Byculla to Pune Cab Service Rates", "Byculla to Pune Taxi Service"],
  ["Mahalaxmi to Pune Cab Service", "Colaba to Pune Taxi"],
  ["Parel to Pune Cab Service", "Sion to Pune Cab Booking"],
  ["Wadala to Pune Cab Booking", "Byculla Cabs Service"],
  ["Outstation Cab Service in Byculla", "Outstation Cab Service in Byculla Number"],
  ["Outstation Cab Service in Byculla Number Mumbai"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Byculla to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and punctual cab services from Byculla to Pune. Whether it's a business trip or a weekend getaway, we ensure a comfortable and timely journey every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained sedans, SUVs, and premium cars, all equipped with AC, ample legroom, and modern features to make your ride from Byculla to Pune relaxing and stress-free."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, courteous, and knowledgeable about the route from Byculla to Pune. They focus on safety and punctuality, ensuring a smooth and worry-free journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive rates with no hidden charges. Skyline Cabs offers transparent pricing for your Byculla to Pune ride, giving you great service at an honest price."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether it’s early morning or late at night, you can book a Skyline Cab from Byculla to Pune anytime. We’re here to serve you round the clock, whenever you need a ride."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Book your ride in just a few clicks through our website or mobile app. With instant booking confirmation and real-time tracking, managing your Byculla to Pune cab ride has never been easier."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs",
        "WhyChoosedescription": "Your safety is our top priority. Every vehicle is thoroughly cleaned and sanitized before each trip, and our drivers follow strict hygiene protocols to ensure a safe travel experience."
    },
    {
        "WhyChooseheading": "Vehicle Options for Every Need",
        "WhyChoosedescription": "From solo travelers to families or small groups, we have the right vehicle for everyone. Choose from sedans, SUVs, or even luxury cabs to suit your Byculla to Pune travel needs."
    }
]



























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Byculla to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Byculla to Pune with Skyline Cabs is easy and quick. Just use our website, mobile app, or call our customer support. Enter your pickup and drop-off locations, choose a vehicle, and confirm your booking in minutes.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Byculla to Pune journey?',
            answer:
                'We offer a wide range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. You can select a vehicle based on your comfort preferences and the number of passengers.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Byculla to Pune?',
            answer:
                'The average travel time from Byculla to Pune is approximately 3.5 to 5 hours, depending on the traffic. Our experienced drivers ensure a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Byculla to Pune cab fixed?',
            answer:
                'Yes, Skyline Cabs provides fixed and transparent fares that include tolls, taxes, and driver charges. You will know the full price upfront before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Byculla to Pune?',
            answer:
                'Yes, round-trip bookings are available. Simply enter your return trip details while booking, and we’ll arrange a comfortable round-trip cab for you.',
        },
        {
            id: 6,
            question: 'Can I change or cancel my Byculla to Pune cab booking?',
            answer:
                'Yes, you can easily modify or cancel your booking through our app, website, or customer support. We offer flexible options to suit your changing plans.',
        },
        {
            id: 7,
            question: 'Are the cabs clean and well-maintained?',
            answer:
                'Absolutely. All our vehicles are regularly maintained, cleaned, and sanitized to ensure your safety and comfort throughout the ride.',
        },
        {
            id: 8,
            question: 'What payment methods are available for my Byculla to Pune ride?',
            answer:
                'You can pay securely online via UPI, credit/debit cards, or net banking. Cash payments at the end of the ride are also accepted.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs a good option for corporate travel from Byculla to Pune?',
            answer:
                'Yes, we provide reliable and professional cab services for corporate travel. Whether it’s a meeting, conference, or group travel, we offer tailored packages to suit business needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Byculla to Pune journey?',
            answer:
                'Skyline Cabs offers punctual service, professional drivers, clean vehicles, and upfront pricing. We ensure a stress-free and pleasant journey from Byculla to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Took a Skyline Cab from Byculla to Pune and had a great experience. The ride was smooth, the vehicle was clean, and the driver was courteous. Highly recommended!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "The cab service from Byculla to Pune was very good. Comfortable car and a friendly driver. The booking process was seamless too!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Byculla to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/byculla-to-pune-cab.jpg",
  "description": "Book Byculla to Pune cab with Skyline Cabs for a reliable and comfortable journey. Choose AC sedans, SUVs, or premium cars with professional drivers — available 24/7 for one-way or round-trip rides.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7123"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/byculla-to-pune-cab"
  }
};


      
      



    return (
        <div>


<Helmet>
  <title>Byculla to Pune Cab | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Byculla to Pune cab with Skyline Cabs for a reliable and comfortable journey. Choose AC sedans, SUVs, or premium cars with professional drivers — available 24/7 for one-way or round-trip rides." 
  />
  <meta 
    name="keywords" 
    content="Byculla to Pune Cab, Cab from Byculla to Pune, One-Way Taxi Byculla to Pune, Round Trip Cab Byculla to Pune, AC Cab Byculla to Pune, SUV Taxi Byculla to Pune, Skyline Cabs Byculla to Pune, Online Cab Booking Byculla to Pune, Affordable Taxi Byculla to Pune, 24/7 Cab Byculla to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/59.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bycullatopunecabservice;